<script>
export default {
    name: 'SiteFooter',
};
</script>

<template>
    <footer class="site-footer">
        <div class="site-footer__content">
            <article class="site-footer__article">
                <p class="site-footer__address">
                    Hug Gruppe AG<br>
                    Grossmatte 22<br>
                    CH-6014 Luzern
                </p>
                <p class="site-footer__address">
                    <a href="https://hug-gruppe.ch" class="site-footer__link">hug-gruppe.ch</a>
                </p>
            </article>
        </div>
    </footer>
</template>

<style lang="scss" scoped>
@import '../styles/variables';
.site-footer {
    position: absolute;
    bottom: 0; left: 0;
    width: 100%;

    @media (max-width: 960px) {
        position: relative;
    }
}
.site-footer__content {
    width: 55.6875rem;
    margin: 0 auto;

    @media (max-width: 960px) {
        width: 100%;
    }
}
.site-footer__article {
    position: relative;
    box-sizing: border-box;
    width: 17.1875rem;
    margin: 0 0 0 37.8125rem;
    padding: 1.5rem .78125rem;
    font-size: 1.125rem;
    line-height: 1.222;
    color: $color-light;

    @media (max-width: 960px) {
        margin: 0 auto;
    }
}
.site-footer__link {
    color: $color-light;
    text-decoration: none;
}
</style>
